// Product Item Slider Functions
function initializeProductSliders() {
  const productSliders = document.querySelectorAll('.ProductItem__Swiper');
  
  productSliders.forEach(function(sliderElement) {
    // Check if Swiper is already initialized
    if (sliderElement.swiper) {
      sliderElement.swiper.destroy();
    }
    
    // Only initialize if there are multiple slides
    const slides = sliderElement.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) {
      return;
    }
    
    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not loaded');
      return;
    }
    
    // Verificar se os elementos de paginação e navegação existem
    const paginationEl = sliderElement.querySelector('.ProductItem__SwiperPagination');
    const nextEl = sliderElement.querySelector('.ProductItem__SwiperButtonNext');
    const prevEl = sliderElement.querySelector('.ProductItem__SwiperButtonPrev');
    
    try {
      // Initialize Swiper
      const swiper = new Swiper(sliderElement, {
        slidesPerView: 1,
        spaceBetween: 4,
        loop: true,
        autoplay: false,
        allowTouchMove: true,
        grabCursor: true,
        watchOverflow: true,
        speed: 300, // Fast transition for hover effect
        
        // Pagination
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true,
          dynamicBullets: false,
        } : false,
        
        // Navigation arrows
        navigation: (nextEl && prevEl) ? {
          nextEl: nextEl,
          prevEl: prevEl,
        } : false,
        
        // Responsive breakpoints
        breakpoints: {
          320: {
            allowTouchMove: true,
          },
          768: {
            allowTouchMove: true,
          }
        },
        
        // Events
        on: {
          init: function() {
            // Add custom classes for styling
            sliderElement.classList.add('swiper-initialized');
          },
          slideChange: function() {
            // Optional: Add any slide change logic here
          }
        }
      });
      
      // Store swiper instance on element
      sliderElement.swiper = swiper;
      
       // Add hover effect for desktop only
       if (window.matchMedia('(hover: hover)').matches) {
         const productItem = sliderElement.closest('.ProductItem');
         if (productItem) {
           let isHovered = false;
           
           // Function to go to second slide
           function goToSecondSlide() {
             if (swiper.slides.length > 1) {
               // Always go to the real second slide (index 1)
               // Use slideToLoop to handle infinite loop correctly
               swiper.slideToLoop(1, 0); // Move to second slide INSTANTLY (0ms)
             }
           }
           
           // Function to go back to first slide
           function goToFirstSlide() {
             if (swiper.slides.length > 1) {
               // Force return to the real first slide, handling infinite loop
               // Use slideToLoop to ensure we always go to the correct first slide
               swiper.slideToLoop(0, 0);
             }
           }
           
           // Hover enter - move to slide 2 (index 1) INSTANTANEOUSLY
           productItem.addEventListener('mouseenter', function() {
             isHovered = true;
             goToSecondSlide();
           });
           
           // Hover leave - move back to slide 1 (index 0) INSTANTANEOUSLY
           productItem.addEventListener('mouseleave', function() {
             isHovered = false;
             goToFirstSlide();
           });
           
           
           

           
           // Force return to first slide when mouse leaves the viewport
           document.addEventListener('mouseleave', function() {
             isHovered = false;
             goToFirstSlide();
           });
           

         }
       }
    } catch (error) {
      console.warn('Error initializing Swiper:', error);
    }
  });
}

// Product Item Slider Initialization
document.addEventListener("DOMContentLoaded", function() {
  initializeProductSliders();
});

/**
 * Initialize only ProductItem Swipers that are not yet initialized (e.g. after infinite scroll append).
 * Use this to avoid destroying and re-creating all sliders when appending new cards.
 * @param {Element} container - Parent element containing the new .ProductItem__Swiper elements (e.g. the ProductList grid)
 */
function initNewProductSliders(container) {
  if (!container || typeof Swiper === 'undefined') return;
  const sliders = container.querySelectorAll('.ProductItem__Swiper');
  sliders.forEach(function(sliderElement) {
    if (sliderElement.swiper) return;
    const slides = sliderElement.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;
    const paginationEl = sliderElement.querySelector('.ProductItem__SwiperPagination');
    const nextEl = sliderElement.querySelector('.ProductItem__SwiperButtonNext');
    const prevEl = sliderElement.querySelector('.ProductItem__SwiperButtonPrev');
    try {
      const swiper = new Swiper(sliderElement, {
        slidesPerView: 1,
        spaceBetween: 4,
        loop: true,
        autoplay: false,
        allowTouchMove: true,
        grabCursor: true,
        watchOverflow: true,
        speed: 300,
        pagination: paginationEl ? { el: paginationEl, clickable: true, dynamicBullets: false } : false,
        navigation: (nextEl && prevEl) ? { nextEl: nextEl, prevEl: prevEl } : false,
        breakpoints: { 320: { allowTouchMove: true }, 768: { allowTouchMove: true } },
        on: {
          init: function() { sliderElement.classList.add('swiper-initialized'); }
        }
      });
      sliderElement.swiper = swiper;
      if (window.matchMedia('(hover: hover)').matches) {
        var productItem = sliderElement.closest('.ProductItem');
        if (productItem) {
          productItem.addEventListener('mouseenter', function() {
            if (swiper.slides.length > 1) swiper.slideToLoop(1, 0);
          });
          productItem.addEventListener('mouseleave', function() {
            if (swiper.slides.length > 1) swiper.slideToLoop(0, 0);
          });
        }
      }
    } catch (e) { console.warn('Error initializing new Swiper:', e); }
  });
}

// Re-initialize sliders when new content is loaded (for infinite scroll, etc.)
document.addEventListener("shopify:section:load", function(event) {
  if (event.target.querySelector('.ProductItem__Swiper')) {
    initializeProductSliders();
  }
});

// Related products carousel observer + infinite scroll: only init new sliders, don't destroy existing ones
document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        try {
          if (node.querySelector && node.querySelector('.ProductItem__Swiper')) {
            setTimeout(function() {
              var container = node.nodeType === 1 && node.classList && node.classList.contains('Grid__Cell') ? node.parentElement : node;
              if (container && typeof initNewProductSliders === 'function') {
                initNewProductSliders(container);
              }
            }, 100);
          }
        } catch (error) {
          console.warn('Error in observer:', error);
        }
      });
    });
  });
  try {
    observer.observe(document.body, { childList: true, subtree: true });
  } catch (error) {
    console.warn('Error setting up observer:', error);
  }
});



// Product Slider functionality moved to product-slider.js

// // Optional: Pause autoplay on hover (if autoplay is enabled)
// document.addEventListener('mouseenter', function(event) {
//   const slider = event.target.closest('.ProductItem__Swiper');
//   if (slider && slider.swiper && slider.swiper.autoplay) {
//     slider.swiper.autoplay.stop();
//   }
// }, true);

// document.addEventListener('mouseleave', function(event) {
//   const slider = event.target.closest('.ProductItem__Swiper');
//   if (slider && slider.swiper && slider.swiper.autoplay) {
//     slider.swiper.autoplay.start();
//   }
// }, true);
